import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchCompany, updateCompany } from "actions/company";
import { fetchAvailableGateways } from "actions/availableGateway";
import { fetchRateLimits } from "actions/rateLimit";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import isEmpty from "lodash.isempty";

import dateUtil from "utils/date";

import Form from "pages/Company/Form";

class CompanyEdit extends Component {
  componentDidMount() {
    const {
      match,
      fetchCompany,
      fetchRateLimits,
      fetchAvailableGateways
    } = this.props;
    const id = match.params.companyId;
    fetchCompany(id);
    fetchRateLimits();
    fetchAvailableGateways();
  }

  shapedDefaultValuesStructure() {
    const {
      expired_at,
      payment_gateways,
      users,
      ...rest
    } = this.props.company.data;

    return Object.assign(
      {},
      {
        ...rest,
        available_gateways:
          payment_gateways && payment_gateways.map(g => g.gateway_id),
        admin_email: !isEmpty(users) && users[0].email,
        expired_at: dateUtil.phpFormatToJS(expired_at)
      }
    );
  }

  updateCompany(id, data) {
    const {
      toggleNotification,
      toggleFullPageSpinner,
      updateCompany,
      history
    } = this.props;

    toggleFullPageSpinner(true);

    updateCompany(id, data)
      .then(() => {
        toggleNotification(true, {
          message: "Updated Company Success",
          infoClassName: "is-success"
        });
        history.push(`/companies`);
      })
      .catch(e => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger"
        });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const id = this.props.match.params.companyId;

    this.updateCompany(id, data);
  };

  render() {
    const { company, rateLimits, availableGateways } = this.props;

    if (company.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return (
      <Form
        handleFormSubmit={this.handleFormSubmit}
        defaultValues={defaultValues}
        rateLimits={rateLimits}
        availableGateways={availableGateways}
      />
    );
  }
}

const mapStateToProps = ({ company, rateLimits, availableGateways }) => ({
  company,
  rateLimits,
  availableGateways
});

export default connect(mapStateToProps, {
  fetchRateLimits,
  fetchAvailableGateways,
  fetchCompany,
  updateCompany,
  toggleFullPageSpinner,
  toggleNotification
})(CompanyEdit);



// WEBPACK FOOTER //
// ./src/pages/Company/Edit/index.js